/*
  Input Checkbox
*/

import React from 'react';

// Antd
import { Checkbox, Form } from 'antd';

// Style
import './style.scss';

function CheckboxItem({ 
  name, label, defaultValue, 
  onChange, disabled,
  notwrapInForm, checked,
  style, onClick
}) {
  // Input Text
  const InputCheckbox = (
    <Checkbox 
      onChange={ onChange || null } 
      defaultValue={ defaultValue }
      disabled={ disabled }
      checked={checked}
      style={style}
      onClick={onClick}
    >
      { label }
    </Checkbox>
  );

  return(
    !!notwrapInForm?
      <>
        { InputCheckbox }
      </>:
      <Form.Item
        name={ name }
        valuePropName="checked"
      >
        { InputCheckbox }
      </Form.Item>

  );
}

export default CheckboxItem;